/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Step_1Inputs */

const en_svc_rag_step_1 = /** @type {(inputs: Svc_Rag_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the sources that are approved, current and owned by someone.`)
};

const lv_svc_rag_step_1 = /** @type {(inputs: Svc_Rag_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izvēlamies avotus, kas ir apstiprināti, aktuāli un kuriem ir atbildīgais.`)
};

/**
* | output |
* | --- |
* | "Choose the sources that are approved, current and owned by someone." |
*
* @param {Svc_Rag_Step_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_step_1 = /** @type {((inputs?: Svc_Rag_Step_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Step_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_step_1(inputs)
	return en_svc_rag_step_1(inputs)
});